export const ISSUE_PARENT_PANEL = 'Epic';
export const VERSION_PANEL = 'Version';

export const ISSUE_PARENT_PANEL_SHORTCUT = 'E' as const;
export const VERSION_PANEL_SHORTCUT = 'V' as const;
